import React from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import { makeStyles } from '@material-ui/core/styles';

import { motion } from 'framer-motion';

import { FAQChildren } from './animation/variants';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  wrapper: {
    boxShadow: 'none',
  },
  questionWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  question: {
    fontSize: '28px',
    lineHeight: '36px',
    letterSpacing: '-0.03em',
  },
  dropdown: {
    transform: 'rotate(90deg)',
    color: '#000000',
  },
}));

const QuestionDropdown = ({ question, answer }) => {
  const classes = useStyles();

  return (
    <motion.div variants={FAQChildren}>
      <Accordion className={classes.wrapper}>
        <AccordionSummary
          expandIcon={<PlayArrowIcon className={classes.dropdown} />}>
          <b className={classes.question}>{question}</b>
        </AccordionSummary>
        <AccordionDetails>{answer}</AccordionDetails>
      </Accordion>
    </motion.div>
  );
};

export default QuestionDropdown;
